module.exports = {
  __depends__: [
    require(221),
    require(165),
    require(248),
    require(184),
    require(176),
    require(256),
    require(25)
  ],
  __init__: [ 'paletteProvider' ],
  paletteProvider: [ 'type', require(77) ]
};
